import { Button, Snackbar, Tooltip } from "@material-ui/core";
import { PlayArrow, Replay, Stop } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import PinDropIcon from "@material-ui/icons/PinDrop";
import ScheduleIcon from "@material-ui/icons/Schedule";
import IpadIcon from "@material-ui/icons/TabletMacOutlined";
import WavesIcon from '@material-ui/icons/Waves';
import MuiAlert from "@material-ui/lab/Alert";
import GavelIcon from '@material-ui/icons/Gavel';
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deleteRegatta,
	getRegattas,
	resetRegattaStats,
	updateRegatta,
} from "../../../../api/regatta";
import { FRONT_URL } from "../../../../utils";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import WindDialog from "../../../components/dialogs/WindDialog";
import Table, {
	booleanFormatter,
	buttonsStyle,
} from "../../../components/tables/table";
import { getClubs } from "../../../../api/club";
import ParticipantsModal from "../../../components/dialogs/ParticipantsModal";
import HeatsModal from "../../../components/dialogs/HeatsModal";
import BuoysModal from "../../../components/dialogs/BuoysModal";
import JudgesModal from "../../../components/dialogs/JudgesModal";
import { Badge } from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";

function getData(regattas, clubs) {
	
	let data = [];
	for (let i = 0; i < regattas.length; ++i) {
		const elem = {};
		elem.name = regattas[i].fullName;
		// sponsor es opcional: sin optional chaining, una regata sin sponsor tumbaba la página entera
		elem.sponsorname = regattas[i].sponsor?.name || "---";
		elem.numParticipants = regattas[i].numParticipants || 0;
		elem.numJudges = regattas[i].numRegattaJudges || 0;
		elem.numBuoys = regattas[i].numBuoys || 0;
		elem.numHeats = regattas[i].heats?.length || 0;
		elem.regattaDate = regattas[i].regattaDate
			? new Date(regattas[i].regattaDate).toLocaleDateString("es-ES")
			: "---";
		elem.createdAt = regattas[i].createdAt;
		elem.default = regattas[i].default;
		elem.active = regattas[i].active;
		elem.data = regattas[i];
		// el backend devuelve club POPULADO (objeto); antes se buscaba como id y siempre salía "---"
		elem.club = regattas[i].club?.fullName
			|| clubs.find((cat) => cat._id === regattas[i].club)?.fullName
			|| "---";
		elem.id = regattas[i]._id;
		data = data.concat(elem);
	}
	return data;
}

export default function RegattasPage() {
	const [data, setData] = useState([]);
	const [regattaId, setRegattaId] = useState(null);
	const [selectedRegatta, setSelectedRegatta] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const [copiedLink, setCopiedLink] = useState(false);
	const [openParticipantsModal, setOpenParticipantsModal] = useState(false);
	const [openHeatsModal, setOpenHeatsModal] = useState(false);
	const [openJudgesModal, setOpenJudgesModal] = useState(false);
	const [openBuoysModal, setOpenBuoysModal] = useState(false);
	const [openWindDialog, setOpenWindDialog] = useState(false);
	const [selectedRegattaId, setSelectedRegattaId] = useState(null);
	const [selectedRegattaForHeats, setSelectedRegattaForHeats] = useState(null);
	const history = useHistory();
	
	
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);
	const isJudge = user?.role === "judge" ? true : false;
	const isClubManager = user?.role === "club_manager" ? true : false;

	function buttonFormatter(cell, row) {
		const regatta = cell;

		return (
			<>
				<Tooltip title="Participants">
					<Badge badgeContent={cell.numParticipants || 0} color="secondary">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setSelectedRegattaId(cell._id);
								setOpenParticipantsModal(true);
							}}
						>
							<AccountCircleIcon />
						</Button>
					</Badge>
				</Tooltip>
				<Tooltip title="Judges">
					<Badge badgeContent={row.numJudges || 0} color="secondary">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setSelectedRegattaId(cell._id);
								setOpenJudgesModal(true);
							}}
						>
							<GavelIcon />
						</Button>
					</Badge>
				</Tooltip>
				<Tooltip title="Buoys">
					<Badge badgeContent={cell.numBuoys || 0} color="secondary">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setSelectedRegattaId(cell._id);
								setOpenBuoysModal(true);
							}}
						>
							<PinDropIcon />
						</Button>
					</Badge>
				</Tooltip>
				<Tooltip title="Heats">
					<Badge badgeContent={row.numHeats || 0} color="secondary">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => {
								setSelectedRegattaForHeats(cell);
								setOpenHeatsModal(true);
							}}
						>
							<ScheduleIcon />
						</Button>
					</Badge>
				</Tooltip>
				<Tooltip title="Ranking">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() =>
							history.push("/ranking-regatta/" + cell._id)
						}
					>
						<EmojiEventsIcon />
					</Button>
				</Tooltip>
				<Tooltip title="View regatta">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							navigator.clipboard.writeText(
								`${FRONT_URL}?regatta=${cell._id}`
							);
							setCopiedLink(true);
						}}
					>
						<IpadIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Edit">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/edit-regatta/" + cell._id)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				<Tooltip title="Delete">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => {
							setRegattaId(cell._id);
							setOpenConfirmDialog(2);
						}}
					>
						<DeleteIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const handleParticipantsChange = (regattaId, newParticipantCount) => {
		console.log(`Updating participant count for regatta ${regattaId}: ${newParticipantCount}`);
		
		// Actualizar el estado data con el nuevo conteo
		setData(prevData => 
			prevData.map(regatta => 
				regatta.id === regattaId 
					? { ...regatta, data: { ...regatta.data, numParticipants: newParticipantCount } }
					: regatta
			)
		);
	};

	const handleJudgesChange = (regattaId, newJudgeCount) => {
		setData(prevData =>
			prevData.map(regatta =>
				regatta.id === regattaId
					? {
						...regatta,
						numJudges: newJudgeCount,
						data: { ...regatta.data, judges: Array(newJudgeCount).fill(0) }
					}
					: regatta
			)
		);
	};

	const handleBuoysChange = (regattaId, newBuoyCount) => {
		setData(prevData =>
			prevData.map(regatta =>
				regatta.id === regattaId
					? {
						...regatta,
						data: {
							...regatta.data,
							numBuoys: newBuoyCount
						}
					}
					: regatta
			)
		);
	};


	const handleHeatsChange = (updatedHeats) => {
		if (!selectedRegattaForHeats) return;

		const regattaId = selectedRegattaForHeats._id;
		const updatedRegatta = {
			...selectedRegattaForHeats,
			heats: updatedHeats
		};

		// Actualizar el regatta seleccionado
		setSelectedRegattaForHeats(updatedRegatta);

		// Actualizar la tabla
		setData(prevData => 
			prevData.map(regatta => 
				regatta.id === regattaId 
					? { 
						...regatta, 
						numHeats: updatedHeats.length,
						data: updatedRegatta
					}
					: regatta
			)
		);

		// Actualizar en el backend
		updateRegatta(regattaId, updatedRegatta)
			.then((res) => {
				if (res.status === 200) {
					console.log("Heats updated successfully in backend");
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not save heats changes.",
				});
			});
	};

	const handleOpenWindDialog = (regattaId) => {
		setSelectedRegattaId(regattaId);
		setOpenWindDialog(true);
	};

	const columns = [
		{ dataField: "name", text: "Full name", sort: true },
		{ dataField: "club", text: "Club", sort: true },
		{ dataField: "regattaDate", text: "Fecha", sort: true },
		{
			dataField: "wind",
			text: "Forecast",
			formatter: (cell, row) => (
				<Tooltip title="View forecast">
				<WavesIcon
					onClick={() => {
						console.log("Clicked row:", row);
						handleOpenWindDialog(row.data._id);
					}}
					style={{ cursor: "pointer", color: "#3f51b5" }}
				/>
				</Tooltip>
			),
			align: "center",
			headerAlign: "center",
			},
		{
			dataField: "sponsorname",
			text: "Sponsor",
			headerAlign: "center",
			align: "center",
			sort: true,
		},
		{
			dataField: "active",
			text: "Active",
			headerAlign: "center",
			align: "center",
			sort: true,
			formatter: booleanFormatter,
		},
		{
			dataField: "data",
			text: "",
			formatter: buttonFormatter,
			align: "end",
			headerStyle: () => ({ width: "350px" }),
  			style: {  whiteSpace: "nowrap" },
		},
	];

	useEffect(() => {
		getRegattas()
			.then((res) => {
				if (res.status === 200) {
					getClubs()
						.then((respClubs) => {
							if (respClubs.status === 200) {
								setData(getData(res.data, respClubs.data));
								setRefresh(false);
							}
						})
						.catch((error) => {
							alertError({
								error: error,
								customMessage: "Could not get clubs.",
							});
						});
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "Could not get regattas.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Regattas list">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() => history.push("/edit-regatta")}
						>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={"Are you sure you want to remove this regatta?"}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteRegatta(regattaId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: "Deleted!",
											customMessage:
												"Regatta removed successfully.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: "Could not remove regatta.",
									});
								});
						}}
					/>
					<ConfirmDialog
						title="Are you sure you want to set reset all the data associated to this regatta?"
						open={openConfirmDialog === 3}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							resetRegattaStats(regattaId)
								.then((res) => {
									if (res.status === 204) {
										alertSuccess({
											title: "Success!",
											customMessage: `Stats reset successfully`,
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: "Could not reset stats.",
									});
								});
						}}
					>
						{"This will erase all their groups and answers"}
					</ConfirmDialog>
					<ConfirmDialog
						title={`Are you sure you want to ${
							selectedRegatta?.active ? "end" : "start"
						} this regatta?`}
						open={openConfirmDialog === 4}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							updateRegatta(selectedRegatta._id, {
								...selectedRegatta,
								active: !selectedRegatta?.active,
							})
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({
											title: "Success!",
											customMessage: !selectedRegatta?.active
												? "Regatta Started"
												: "Regatta Ended",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"Could not update the regatta.",
									});
								});
						}}
					></ConfirmDialog>
				</CardBody>
			</Card>
			<Snackbar
				open={copiedLink}
				autoHideDuration={6000}
				onClose={() => setCopiedLink(false)}
			>
				<MuiAlert severity="info" sx={{ width: "100%" }}>
					Regatta link copied
				</MuiAlert>
			</Snackbar>
			{openParticipantsModal && (
				<ParticipantsModal
					regattaId={selectedRegattaId}
					show={openParticipantsModal}
					onHide={() => {
						setOpenParticipantsModal(false);
						setSelectedRegattaId(null);
					}}
					onParticipantsChange={handleParticipantsChange}
				/>
			)}
			{openHeatsModal && selectedRegattaForHeats && (
				<HeatsModal
					show={openHeatsModal}
					onHide={() => {
						setOpenHeatsModal(false);
						setSelectedRegattaForHeats(null);
					}}
					regatta={selectedRegattaForHeats}
					onHeatsChange={handleHeatsChange}
				/>
			)}
			{openJudgesModal && (
				<JudgesModal
					regattaId={selectedRegattaId}
					show={openJudgesModal}
					onHide={() => {
						setOpenJudgesModal(false);
						setSelectedRegattaId(null);
					}}
					onJudgesChange={handleJudgesChange}
				/>
			)}
			{openBuoysModal && (
				<BuoysModal
					regattaId={selectedRegattaId}
					show={openBuoysModal}
					onHide={() => {
						setOpenBuoysModal(false);
						setSelectedRegattaId(null);
					}}
					onBuoysChange={handleBuoysChange}
				/>
			)}
			{openWindDialog && (
			<WindDialog
				open={openWindDialog}
				onClose={() => setOpenWindDialog(false)}
				regattaId={selectedRegattaId}
				/>
			)}
		</>
	);
}
